<template>
  <div id="app">
    <transition :name="transitionName">
      <!-- <keep-alive> -->
      <!-- <router-view class="Router" v-if="isRouterAlive" /> -->
      <router-view v-if="isRouterAlive" />
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
import { Toast } from 'vant'
import axios from 'axios'

export default {
  name: 'App',
  provide () { // 注册一个方法
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      transitionName: 'slide-right',
      isRouterAlive: true
    }
  },
  watch: {
    $route (to, from) {
      let isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      if (isBack) {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
      this.$router.isBack = false
    }
  },
  methods: {
    //局部刷新
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  created() {
    // localStorage.setItem("id", "1516302263742705666")
    // localStorage.setItem("accessToken", "998e72d3-c244-4cc5-9c16-c758a75a929c")
    // localStorage.setItem("refreshToken", "b7be9bfc-d60a-4b6c-bdd7-3dcc3ad34655")
    // localStorage.setItem("mobile", "15057068002")
    // localStorage.setItem("appId", "wx1c963ea42376952f")
    // localStorage.setItem("name", "龚隆建")
    // localStorage.setItem("mobile", "15057068002")
    // localStorage.setItem("username", "zj88120220008")
    // localStorage.setItem("moduleId", "201")
  }

};
</script>

<style>
body,
ul,
li,
dl,
dt,
dd,
p,
ol,
h1,
h2,
h3,
h4,
h5,
h6,
form,
img,
table,
fieldset,
legend {
  margin: 0;
  padding: 0;
}
ul,
li,
ol {
  list-style: none;
}
img,
fieldset {
  border: 0;
}
img {
  display: block;
}
a {
  text-decoration: none;
  color: #333;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 100;
}
body {
  font-size: 12px;
  font-family: "微软雅黑";
  background: rgba(255, 255, 255, 1);
  /* position: fixed; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  -webkit-overflow-scrolling: touch;
}
input,
a {
  outline: none;
}
input {
  background-color: none;
  outline: none;
  border: none;
}
.Router {
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100% 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue